/**
 * mSTEM Kit Manager row-action cell (GEN-04, + SMH-04 detail). Renders
 * Detail + Connect + Edit + Delete icon buttons for a single kit row. Class
 * component with bindAll so per-row handlers satisfy react/jsx-no-bind
 * without inline arrow allocations. Mirrors RobotActionsCell pattern from
 * Plan 02-03.
 */
import bindAll from 'lodash.bindall';
import PropTypes from 'prop-types';
import React from 'react';

import styles from './kit-manager-modal.css';

class KitActionsCell extends React.Component {
    constructor (props) {
        super(props);
        bindAll(this, ['handleEdit', 'handleDelete', 'handleConnect', 'handleDetail']);
    }
    handleDetail (e) {
        if (e && e.stopPropagation) e.stopPropagation();
        this.props.onDetail(this.props.row);
    }
    handleEdit (e) {
        if (e && e.stopPropagation) e.stopPropagation();
        this.props.onEdit(this.props.row);
    }
    handleDelete (e) {
        if (e && e.stopPropagation) e.stopPropagation();
        this.props.onDelete(this.props.row.id);
    }
    handleConnect (e) {
        if (e && e.stopPropagation) e.stopPropagation();
        this.props.onConnect(this.props.row);
    }
    render () {
        const {editLabel, deleteLabel, connectLabel, detailLabel} = this.props;
        return (
            <div className={styles.actionsCell}>
                <button
                    aria-label={detailLabel}
                    className={styles.iconBtn}
                    title={detailLabel}
                    type="button"
                    onClick={this.handleDetail}
                >
                    {'ℹ'}
                </button>
                <button
                    className={styles.iconBtn}
                    title={connectLabel}
                    type="button"
                    onClick={this.handleConnect}
                >
                    {'🔗'}
                </button>
                <button
                    className={styles.iconBtn}
                    title={editLabel}
                    type="button"
                    onClick={this.handleEdit}
                >
                    {'✎'}
                </button>
                <button
                    className={styles.iconBtnDanger}
                    title={deleteLabel}
                    type="button"
                    onClick={this.handleDelete}
                >
                    {'×'}
                </button>
            </div>
        );
    }
}

KitActionsCell.propTypes = {
    connectLabel: PropTypes.string.isRequired,
    deleteLabel: PropTypes.string.isRequired,
    detailLabel: PropTypes.string.isRequired,
    editLabel: PropTypes.string.isRequired,
    onConnect: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired,
    onDetail: PropTypes.func.isRequired,
    onEdit: PropTypes.func.isRequired,
    row: PropTypes.shape({id: PropTypes.string.isRequired}).isRequired
};

export default KitActionsCell;
